import { Link } from '@tanstack/react-router'
import { Plus, Trash2 } from 'lucide-react'
import { Button } from '@/components/ui/button'
import { EtainablSpinner } from '@/components/etainabl-spinner'
import { useKbArticles, useDeleteKbArticle } from '@/queries/kb'
import { toast } from 'sonner'
import dayjs from 'dayjs'
import { KbRestrictedBadge } from './KbRestrictedBadge'

export function KbAdminListView() {
  const { data, isLoading } = useKbArticles({})
  const del = useDeleteKbArticle()

  return (
    <div className="container mx-auto max-w-4xl p-6 space-y-4">
      <div className="flex items-center justify-between">
        <h1 className="text-2xl font-semibold">Knowledgebase — Admin</h1>
        <Link to="/admin/kb/new">
          <Button size="sm"><Plus className="mr-1.5 h-4 w-4" />New article</Button>
        </Link>
      </div>

      {isLoading && (
        <div className="py-8 flex justify-center">
          <EtainablSpinner size="sm" />
        </div>
      )}

      {!isLoading && (data?.data.length ?? 0) === 0 && (
        <p className="text-sm text-muted-foreground py-8 text-center">No articles yet.</p>
      )}

      <ul className="divide-y rounded border bg-background">
        {data?.data.map(a => (
          <li key={a._id} className="flex items-center gap-3 px-4 py-3">
            <div className="flex-1 min-w-0">
              <div className="flex items-center gap-2">
                <Link to={`/admin/kb/${a._id}` as never} className="font-medium hover:underline">{a.title}</Link>
                <KbRestrictedBadge article={a} />
              </div>
              <div className="text-xs text-muted-foreground mt-0.5">
                {a.isPublished
                  ? <span className="text-green-700">Published</span>
                  : <span className="text-amber-600">Draft</span>}
                <span className="mx-1.5">·</span>
                {a.viewCount} views
                <span className="mx-1.5">·</span>
                Updated {dayjs(a.updatedAt).fromNow()}
              </div>
            </div>
            <Button
              size="sm"
              variant="ghost"
              onClick={async () => {
                if (!confirm(`Delete "${a.title}"?`)) return
                try {
                  await del.mutateAsync(a._id)
                  toast.success('Article deleted')
                } catch (err) {
                  toast.error((err as Error).message ?? 'Could not delete')
                }
              }}
            >
              <Trash2 className="h-4 w-4 text-destructive" />
            </Button>
          </li>
        ))}
      </ul>
    </div>
  )
}
